import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuiz } from '../contexts/QuizContext';
import QuizContainer from '../components/QuizContainer';
import ProgressBar from '../components/ProgressBar';
import { questions } from '../data/questions';

const Quiz = () => {
  const { currentPhase, currentQuestionIndex, answers } = useQuiz();
  const navigate = useNavigate();
  
  // Verifica se o quiz foi concluído
  useEffect(() => {
    const lastPhase = questions[questions.length - 1];
    const isLastPhase = currentPhase === lastPhase.id;
    const isLastQuestion = currentQuestionIndex === lastPhase.questions.length - 1;
    
    // Se estiver na última pergunta da última fase e já tiver respondido
    if (isLastPhase && isLastQuestion && answers[lastPhase.questions[currentQuestionIndex].id]) {
      // Redireciona para a página de carregamento
      navigate('/loading');
    }
  }, [currentPhase, currentQuestionIndex, answers, navigate]);

  return (
    <>
      <div className="fixed top-0 left-0 z-10 mt-20 w-full flex justify-center">
        <div className="max-w-md md:max-w-2xl w-full">
          <ProgressBar />
        </div>
      </div>
      <div className="pt-28 pb-10">
        <div className="container mx-auto px-4">
          <QuizContainer />
        </div>
      </div>
    </>
  );
};

export default Quiz;
